export default "__VITE_ASSET__ba3bf8c2__"